// @mui
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
//
import { usePortal } from 'src/hooks/use-portal';
import { Stack } from '@mui/material';
import { useResponsive } from 'src/hooks/use-responsive';
import CategoryList from '../category-list';

// ----------------------------------------------------------------------

export default function CategoryListHomeView({ isRTL }: any) {
  const { categories, loading } = usePortal({});
  const mdUp = useResponsive('up', 'md');

  return (
    <Container maxWidth={mdUp ? 'xl' : false}>
      <Stack spacing={5} sx={{ textAlign: 'center', my: mdUp ? 5 : 3, mt: 5 }}>
        <Typography variant="h2">{isRTL ? 'انواع الوجبات' : 'Meal Types'}</Typography>
      </Stack>
      <CategoryList categories={categories} loading={loading} />
    </Container>
  );
}
